import classnames from 'classnames';
import propTypes from 'prop-types';
import React from 'react';
import Date from '../../common/date';
import DateTime from '../../common/DateTime';

const QueueItem = ({ email, createdAt, finishedAt, status, startDate, endDate }) => (
  <div className="u-fontsize-small u-border-bottom u-pv- dark-mode-white">
    <p>Email: {email}</p>
    <p display-if={startDate && endDate}>
      Date range: <Date>{startDate}</Date> - <Date>{endDate}</Date>
    </p>
    <p>Started at: <DateTime>{createdAt}</DateTime></p>
    <p display-if={finishedAt}>Finished at: <DateTime>{finishedAt}</DateTime></p>
    <p>Status:{' '}
      <span
        className={classnames('u-type--bold', {
          'u-font-color-primary': status === 'finished',
          'u-font-color-red': status === 'failed',
        })}
      >
        {status}
      </span>
    </p>
  </div>
);

QueueItem.propTypes = {
  email: propTypes.string.isRequired,
  createdAt: propTypes.string.isRequired,
  finishedAt: propTypes.string,
  status: propTypes.string.isRequired,
  startDate: propTypes.string,
  endDate: propTypes.string,
};

QueueItem.defaultProps = {
  finishedAt: '',
  startDate: '',
  endDate: '',
};

export default QueueItem;
